import {Params} from '@mc/react-mapio';

// Helper pro dekódování Base64 na objekt
export const decodeBase64 = (value: string): Record<string, any> => {
    if (!value) return {}; // Pokud je hodnota prázdná, vrátíme prázdný objekt
    try {
        const decodedString = Buffer.from(value, 'base64').toString('utf-8');
        if (!decodedString.trim()) {
            console.warn('Decoded Base64 string is empty.');
            return {}; // Pokud je dekódovaný string prázdný, vrátíme prázdný objekt
        }
        const params = new URLSearchParams(decodedString);
        const obj: Record<string, any> = {};
        for (let [key, value] of params.entries()) {
            obj[key] = value;
        }
        return obj;
    } catch (error) {
        console.error('Chyba při dekódování hodnoty:', error, 'Base64 string:', value);
        return {}; // Pokud dekódování selže, vrátíme prázdný objekt
    }
};

// Helper pro zakódování objektu do Base64
export const encodeBase64 = (value: Record<string, any>): string => {
    if (!value) return ''; // Pokud je hodnota prázdná, vrátíme prázdný string

    try {
        const params = new URLSearchParams();
        for (const [key, val] of Object.entries(value)) {
            params.append(key, val as string);
        }
        return Buffer.from(params.toString(), 'utf-8').toString('base64');
    } catch (error) {
        console.error('Chyba při kódování hodnoty:', error, 'Object:', value);
        return ''; // Pokud kódování selže, vrátíme prázdný string
    }
};

/**
 * Aktualizuje hodnotu kontextu.
 * @param currentContext - Aktuální hodnota mapioContext.value.context (může být null, Base64 nebo objekt).
 * @param newValue - Nová hodnota, která se má přidat nebo nahradit (může být Base64 nebo objekt).
 * @returns Aktualizovaná hodnota kontextu jako Base64 zakódovaný string.
 */
export const updateContext = (currentContext: null | string | Record<string, any>, newValue: string | Record<string, any>): string => {
    // Pokud je currentContext null, nastavíme jej na prázdný objekt
    currentContext ??= {};

    // Dekódování currentContext, pokud je Base64
    let decodedCurrentContext: Record<string, any> = {};
    if (typeof currentContext === 'string') {
        decodedCurrentContext = decodeBase64(currentContext);
    } else {
        decodedCurrentContext = currentContext;
    }

    // Dekódování newValue, pokud je Base64
    let decodedNewValue: Record<string, any> = {};
    if (typeof newValue === 'string') {
        decodedNewValue = decodeBase64(newValue);
    } else {
        decodedNewValue = newValue;
    }

    // Sloučení nových hodnot s aktuálním kontextem
    const mergedContext = {
        ...decodedCurrentContext,
        ...decodedNewValue,
    };

    // Zakódování výsledného kontextu do Base64
    return encodeBase64(mergedContext);
};

export const convertContextToParams = (context: string): Params => {
    if (!context) return {};
    const decodedString = Buffer.from(context, 'base64').toString('utf-8');
    const params = new URLSearchParams(decodedString);

    let obj = {};
    for (let [key, value] of params.entries()) {
        obj[key] = value;
    }

    return obj;
};
